import { connect } from 'react-redux';

import actionGetManagerComplaints from 'store/manager-complaint/action';
import ManagerComplaint from './ManagerComplaint';

const mapStateToProps = (state) => ({
  isLoadingGetManagerComplaints: state.ManagerComplaint.isLoadingGetManagerComplaints,
  managerComplaints: state.ManagerComplaint.managerComplaints,
  totalManagerComplaints: state.ManagerComplaint.totalManagerComplaints,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetManagerComplaints: (payload) => dispatch(actionGetManagerComplaints(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerComplaint);
